import { EmailModalState, EmailModalAction } from './types';

// Email Modal Initial State
export const InitialEmailModalState: EmailModalState = {
  formData: {
    selectedTemplate: null,
    excludeApplicants: false,
    delay: 'None',
    subject: '',
    body: '',
    attachments: []
  },
  errors: {},
  snackbar: { message: '', state: 'success' }
};

// Email Modal Reducer
export const EmailModalReducer = (
  state: EmailModalState,
  action: EmailModalAction
): EmailModalState => {
  switch (action.type) {
    case 'SET_FORM_DATA':
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
        errors: {} // Clear errors when form data changes
      };
    case 'SET_ERRORS':
      return {
        ...state,
        errors: { ...state.errors, ...action.payload }
      };
    case 'CLEAR_ERRORS':
      return {
        ...state,
        errors: {}
      };
    case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: action.payload
      };
    case 'RESET_FORM':
      return InitialEmailModalState;
    default:
      return state;
  }
};
